import { axiosCreate } from '@/services/Api'
export default async function({ slug }) {
  const result = await axiosCreate.get(`/custitems/slug/${slug}`)

  return result.data
}
